import React from "react";
import axios from "axios";
import { Button, ChevronDown, Menu, PauseCircle, PlayCircle, Send01 } from "@opendate-app/setlist";

import { toastSuccess, toastError } from "../../../../shared/toastHelper";
import { useActionContext } from "./ActionContainer";

const ActionDropdown = () => {
  const {
    csrfToken,
    team,
    campaign,
    campaignState,
    setCampaignState,
    setTestModalOpen,
    isEmailTemplate,
  } = useActionContext();

  const updateCampaign = (data) => {
    axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;
    axios.put(`/teams/${team.id}/campaigns/${campaign.id}`, data)
      .then(({ data }) => {
        setCampaignState(data.state);
        toastSuccess("Automation has been updated");
      })
      .catch(_error => toastError("Could not update automation, please try again"));
  };

  const items = [
    ...(campaignState === "active" ? [{ label: "Pause Automation", icon: PauseCircle, onClick: () => updateCampaign({ state: "paused" }) }] : []),
    ...(campaignState === "paused" ? [{ label: "Resume Automation", icon: PlayCircle, onClick: () => updateCampaign({ state: "active" }) }] : []),
    ...(isEmailTemplate ? [{ label: "Send Test", icon: Send01, onClick: () => setTestModalOpen(true) }] : []),
  ];

  if (items.length === 0) return null;

  return (
    <Menu
      placement="bottom-end"
      trigger={<Button trailingIcon={ChevronDown}>Actions</Button>}
      items={items}
    />
  );
};

export default ActionDropdown;
